module.exports = __webpack_public_path__ + "img/face-usecase-cosplay.6c721503.webp";